var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnexpectedErrorIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 250,
    viewBox: "0 0 320 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 100C64.4183 100 68 96.4183 68 92C68 87.5817 64.4183 84 60 84C55.5817 84 52 87.5817 52 92C52 96.4183 55.5817 100 60 100Z",
    fill: "#DDDDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M252 72C255.314 72 258 69.3137 258 66C258 62.6863 255.314 60 252 60C248.686 60 246 62.6863 246 66C246 69.3137 248.686 72 252 72Z",
    fill: "#5770C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M276 130C281.523 130 286 125.523 286 120C286 114.477 281.523 110 276 110C270.477 110 266 114.477 266 120C266 125.523 270.477 130 276 130Z",
    stroke: "#CFCFDA",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 150L96 124H216L190 150H70Z",
    fill: "#F0F0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M190 150H70V222H190V150Z",
    fill: "#E6E6EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190 150L216 124V196L190 222V150Z",
    fill: "#D5D5DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178 168L200 146H274L252 168H178Z",
    fill: "#EAEAF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M252 168H178V222H252V168Z",
    fill: "#DCDCE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252 168L274 146V200L252 222V168Z",
    fill: "#CCCCD7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122 78L142 58H196L176 78H122Z",
    fill: "#FF6072"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M176 78H122V222H176V78Z",
    fill: "#F2495C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176 78L196 58V202L176 222V78Z",
    fill: "#DA3B4E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149 116L127 159H171L149 116Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 133.2C151.4 131.985 150.415 131 149.2 131C147.985 131 147 131.985 147 133.2V143.8C147 145.015 147.985 146 149.2 146C150.415 146 151.4 145.015 151.4 143.8V133.2Z",
    fill: "#F2495C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.2 154.9C150.525 154.9 151.6 153.825 151.6 152.5C151.6 151.174 150.525 150.1 149.2 150.1C147.874 150.1 146.8 151.174 146.8 152.5C146.8 153.825 147.874 154.9 149.2 154.9Z",
    fill: "#F2495C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnexpectedErrorIllustration);
export default __webpack_public_path__ + "static/media/unexpected-error-illustration.5d554516462ceb4b3fa2df375b5d1467.svg";
export { ForwardRef as ReactComponent };